import { render, staticRenderFns } from "./saleProductDialog.vue?vue&type=template&id=5d0a5da3"
import script from "./saleProductDialog.vue?vue&type=script&lang=js"
export * from "./saleProductDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports